import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { ButtonCustom, ButtonNoOutLine } from 'app/components/elements/ButtonCustom';
import { IssueModalState } from 'types/issue';

type IssueModalProps = {
  state: IssueModalState;
  onChangeText: (text: string) => void;
  onClose: () => void;
  onSubmit: () => void;
};

export const IssueModal = ({ state, onChangeText, onClose, onSubmit }: IssueModalProps) => {
  return (
    <Dialog open={state.visible} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ paddingBottom: '4px' }}>
        <Stack flexDirection="row" alignItems="flex-start" justifyContent="space-between">
          <Stack>
            <Typography fontSize="16px" fontWeight={600} color="#101828">
              Report an issue
            </Typography>

            <Typography fontSize="12px" color="#6B7280">
              {`X: ${state.xPct}%, Y: ${state.yPct}%`}
            </Typography>
          </Stack>

          <IconButton size="small" onClick={onClose} aria-label="Close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={4}
          autoFocus
          label="Issue"
          placeholder="Describe the issue..."
          value={state.text}
          onChange={(e) => onChangeText(e.target.value)}
        />
      </DialogContent>

      <DialogActions sx={{ padding: '0 24px 20px' }}>
        <ButtonNoOutLine label="Cancel" onClick={onClose} />

        <ButtonCustom label="Submit" disabled={!state.text.trim()} onClick={onSubmit} />
      </DialogActions>
    </Dialog>
  );
};
